/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum SellerValidationError {
    CODE_ALREADY_IN_USE = 'CodeAlreadyInUse',
    EMAIL_ALREADY_IN_USE = 'EmailAlreadyInUse',
}
